// The one definition of the resident profile's sub-tabs (EditPatientComponent).
//
// Hospital (non-eNMRC) sites see the same profile sections as aged care sites -
// prescriber/pharmacy details is the only ePrescribing-specific tab, so it is
// the only one dropped for them. This list used to be duplicated as a second
// hard-coded array for hospital sites, and the copy drifted: its "Entitlement
// Numbers" tab pointed at the `contact_details` panel, so hospital users saw
// the contact form under both tabs (with both highlighted as active) and could
// never reach their entitlement/regulatory numbers. The Clinical section was
// dropped from that copy entirely.

export const PATIENT_PROFILE_TABS = [
  { name: "Personal Information", link: "personal_information" },
  { name: "Clinical", link: "clinical" },
  { name: "Contact Info", link: "contact_details" },
  { name: "Regulatory Numbers", link: "regulatory_numbers" },
  { name: "Prescriber and Pharmacy Details", link: "prescriber_details" },
  // Panels that exist in the template but have never been exposed as tabs:
  //   { name: "Vaccinations and Weights", link: "vaccinations" },
  //   { name: "Diabetes Action Plan", link: "complex" },
  //   { name: "Additional Comments", link: "additional" },
  //   { name: "New Patient Sign Off", link: "sign_off" },
];

export const DEFAULT_PATIENT_PROFILE_TAB = "personal_information";

// Tabs that only mean anything once a site is set up for eNMRC ePrescribing.
const EPRESCRIBING_ONLY_TABS = ["prescriber_details"];

// `completed` is part of the tab shape the template styles off, so every tab
// object gets its own copy rather than sharing the module-level constants.
export function buildPatientProfileTabs(store) {
  const hasEprescribing = !!store?.state?.user?.enmrc_eprescribing_active;
  return PATIENT_PROFILE_TABS.filter(
    (tab) => hasEprescribing || !EPRESCRIBING_ONLY_TABS.includes(tab.link),
  ).map((tab) => ({ ...tab, completed: false }));
}

// A ?subtab= deep link is only honoured when this site actually has that tab,
// so a link copied from an eNMRC site can't strand a hospital user on a panel
// that has no tab to highlight (or no way back).
export function resolvePatientProfileTab(
  tabs,
  requested,
  fallback = DEFAULT_PATIENT_PROFILE_TAB,
) {
  if (
    requested &&
    Array.isArray(tabs) &&
    tabs.some((tab) => tab.link === requested)
  ) {
    return requested;
  }
  return fallback;
}
